export enum JobTypes {
  EVENT_SCREENERS = "EVENT_SCREENERS",
  VIP_PRE_AIR = "VIP_PRE_AIR",
  WB_SCREENERS = "WB_SCREENERS",
  CONTENT_REQUEST_API = "CONTENT_REQUEST_API"
}

export enum SourceLocations {
  MORPH_ENCODING = "MORPH_ENCODING",
  ASPERA = "ASPERA",
}

export enum ProcessorProfiles {
  WECO = "WeCO",
}

export enum ScreenerTypes {
  DCP = "DCP"
}

export enum RequestTypes {
  COPY = "copy",
  REDO = "redo",
}

export enum ScreenerEncryptionTypes {
  POST_HOUSE = "Post House",
  THEATER_PROJECTOR = "Theater Projector",
}